import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Input,
  ViewChild, ElementRef
} from '@angular/core';
import {LayoutService} from '../services/layout.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class HeaderComponent implements OnInit, OnDestroy {

  @ViewChild('mobileMenuRef', { static: true }) mobileMenu: ElementRef<HTMLDivElement>;

  @Input() userIsLogged: boolean;
  @Input() avatarShortName: string;
  @Input() username: string;
  @Input() userEmail: string;

  @Output() signInEventEmitter = new EventEmitter();

  mobileMenuActive: boolean;
  resizeSubscription: Subscription;

  constructor(
    private layoutService: LayoutService
  ) {
    this.mobileMenuActive = false;
  }

  ngOnInit(): void {
    this.resizeSubscription = this.layoutService.onResize()
      .subscribe(e => {
        this.removeMobileMenu();
      });
  }

  signInEventEmit() {
    this.signInEventEmitter.emit();
  }

  setLogoRouterLink() {
    if (this.userIsLogged === true) {
      return '/menu/home';
    } else {
      return '/home';
    }
  }

  toggleMobileMenu() {
    this.mobileMenuActive = !this.mobileMenuActive;
  }
  removeMobileMenu() {
    this.mobileMenuActive = false;
  }

  ngOnDestroy(): void {
    this.resizeSubscription.unsubscribe();
  }
}
